import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiUrlService } from '../common/api-url.service';

export type FeatureFlags = Record<string, boolean>;

/**
 * Transport flag publicznej strony. Woła publiczny endpoint GET client/features
 * (mapa {"nazwa": bool}, tylko flagi macierzy). Bez cache i bez static — czysty transport.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiFeaturesService {
  constructor(
    private httpClient: HttpClient,
    private apiUrlService: ApiUrlService,
  ) {
  }

  getFeatures(): Observable<FeatureFlags> {
    const url = this.apiUrlService.getApiUrl() + 'client/features';
    // Nagłówek wyłącza interceptor ConvertToCamelCase — nazwy flag są kebab-case i nie mogą
    // zostać przekształcone (lodash camelCase('kreator-v2') → 'kreatorV2').
    return this.httpClient.get<FeatureFlags>(url, {headers: {'ignore-camel-case-interceptor': '1'}});
  }
}
